// *********************************
// CoolGames Builder JavaScript file
// *********************************
import { ComponentButton } from "../../framework/components/ComponentButton";
import { ComponentLabel } from "../../framework/components/ComponentLabel";
import { ComponentPicture } from "../../framework/components/ComponentPicture";
import { DialogBase } from "../../framework/dialogs/DialogBase";
import { tgfDictionary } from "../../framework/tgfDictionary";
import { tgfDialogs } from "../../framework/dialogs/tgfDialogs";
import { tgfGraphics } from "../../framework/tgfGraphics";
import { tgfSettings } from "../../framework/tgfSettings";
import { SoundManager } from "../../settings/SoundManager";
import { angrybirds_regular } from "../AssetDefinitions/FontDefinitions";
import { s_black_square, s_popup_darkblue_rect, s_btn_green } from "../AssetDefinitions/ImageDefinitions";
import { playController } from "../gameController";
tgfSettings.dialogDefaults.WarningDialog = {
    width: 800,
    height: 300,
    text: "",
    buttonText: "BTN_OK",
    font: {
        fontFace: angrybirds_regular,
        fontSize: 46,
        fillColor: "#fefefe",
        wordWrap: true,
        wordWrapWidth: 800,
        align: "center",
        baseline: "middle",
        shadow: { active: true, color: 'rgba(50, 49, 65, 0.7)', offsetX: 2, offsetY: 3, blur: 1, distance: 4 }
    },
    components: [] // The additional components to add
};
export var WarningDialog = function (properties) {
    "use strict";
    this.name = "WarningDialog"; // The name of the dialog
    // Initialize properties
    this.initialize(tgfSettings.dialogDefaults.WarningDialog);
    // Set user properties
    if (properties !== undefined) {
        this.setProperties(properties);
    }
};
// Inherit the base dialog
tgfDialogs.inherit(WarningDialog, DialogBase);
WarningDialog.prototype.doPrepare = function () {
    "use strict";
    var self = this;
    this.transparentBlack = new ComponentButton({
        x: tgfGraphics.areaWidth / 2 + -100,
        y: tgfGraphics.areaHeight / 2 + -100,
        xScale: Math.round(tgfGraphics.areaWidth / s_black_square.width) + 20,
        yScale: Math.round(tgfGraphics.areaHeight / s_black_square.height) + 20,
        alpha: 0.7,
        image: s_black_square
    });
    this.addComponent(this.transparentBlack);
    this.background = new ComponentPicture({
        image: s_popup_darkblue_rect,
        createFromSlices: true,
        sliceMarginsArray: [55, 55, 55, 55],
        width: this.width,
        height: this.height,
        x: -(this.width / 2) + 100,
        y: -(this.height / 2) + 100
    });
    this.transparentBlack.addComponent(this.background);
    this.label = new ComponentLabel({
        text: this.text,
        x: 100,
        y: -60 + 100,
        font: this.font,
        width: this.width - 20,
        splitLines: true
    });
    this.transparentBlack.addComponent(this.label);
    this.okButton = new ComponentButton({
        image: s_btn_green,
        text: tgfDictionary.getText(this.buttonText),
        x: 100,
        y: 80 + 100,
        onClick: function () {
            SoundManager.playEffect(SoundManager.UI_STATE.SELECT, SoundManager.UICollection, 0, false);
            self.hide();
            self.free();
            if (playController) {
                playController.activeWarningDialog = null;
            }
            if (self.onClose) {
                self.onClose();
            }
        },
        fontUp: this.font
    });
    this.transparentBlack.addComponent(this.okButton);
    if (playController) {
        playController.activeWarningDialog = this;
    }
};
WarningDialog.prototype.toggleInput = function (enable) {
    if (enable) {
        this.activate();
    }
    else {
        this.deactivate();
    }
};
